import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var generateStyle = function generateStyle(componentTheme, props) {
  var getStatus = function getStatus() {
    var _ref = props.scoredData.value || {},
      resultScore = _ref.resultScore;
    if (resultScore === 1) {
      return 'correct';
    } else if (resultScore <= 0) {
      return 'incorrect';
    }
    return 'unknown';
  };
  var userResponseWrapperVariants = {
    correct: {
      border: "".concat(componentTheme.wrapperBorderWidth, " solid ").concat(componentTheme.correctColor)
    },
    incorrect: {
      border: "".concat(componentTheme.wrapperBorderWidth, " solid ").concat(componentTheme.incorrectColor)
    },
    unknown: {
      border: "".concat(componentTheme.wrapperBorderWidth, " solid ").concat(componentTheme.unknownColor)
    }
  };
  var userResponseTargetVariants = {
    correct: {
      backgroundColor: componentTheme.correctColor
    },
    incorrect: {
      backgroundColor: componentTheme.incorrectColor
    },
    unknown: {
      backgroundColor: componentTheme.unknownColor
    }
  };
  return {
    userResponseWrapper: _objectSpread({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      boxShadow: "0 0 0 1px ".concat(componentTheme.userResponseShadowColor),
      width: '1.2rem',
      height: '1.2rem',
      /* This is done to center the bullseye */
      position: 'absolute',
      transform: 'translate(-50%, -50%)'
    }, userResponseWrapperVariants[getStatus()]),
    userResponseTarget: _objectSpread({
      borderRadius: '50%',
      boxShadow: "0 0 0 1px ".concat(componentTheme.userResponseShadowColor),
      width: '0.5rem',
      height: '0.5rem'
    }, userResponseTargetVariants[getStatus()])
  };
};
export default generateStyle;